export default (theme) => ({
    root: {
        width: '520px !important',
    },
    contentContainer: {
        paddingTop: 25,
    },
    signatureCanvas: {
        border: `solid 1px ${theme.colors.grey[100]}`,
    },
    dropZone: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        boxSizeing: 'borderbox',
        height: 198,
        border: `dashed 1px ${theme.colors.grey[100]}`,
        backgroundColor: theme.colors.actionMinor[50],
        '&:focus': {
            outline: 'none',
        },
    },
    cropImage: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        '& .ReactCrop': {
            position: 'relative',
            display: 'inline-block',
            cursor: 'crosshair',
            overflow: 'hidden',
            maxWidth: '100%',
            backgroundColor: theme.colors.utility.textPrimary,
        },
        '& .ReactCrop:focus': {
            outline: 'none',
        },
        '& .ReactCrop--disabled, .ReactCrop--locked': {
            cursor: 'inherit',
        },
        '& .ReactCrop__image': {
            display: 'block',
            maxWidth: '100%',
            touchAction: 'manipulation',
        },
        '& .ReactCrop--crop-invisible .ReactCrop__image': {
            opacity: '0.5',
        },
        '& .ReactCrop__crop-selection': {
            position: 'absolute',
            top: '0',
            left: '0',
            transform: 'translate3d(0, 0, 0)',
            boxSizing: 'border-box',
            cursor: 'move',
            boxShadow: '0 0 0 9999em rgba(0, 0, 0, 0.5)',
            touchAction: 'manipulation',
            border: '1px solid',
            borderImageSource:
                'url("data:image/gif;base64,R0lGODlhCgAKAJECAAAAAP///////wAAACH/C05FVFNDQVBFMi4wAwEAAAAh/wtYTVAgRGF0YVhNUDw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6OEI5RDc5MTFDNkE2MTFFM0JCMDZEODI2QTI4MzJBOTIiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6OEI5RDc5MTBDNkE2MTFFM0JCMDZEODI2QTI4MzJBOTIiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoTWFjaW50b3NoKSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuZGlkOjAyODAxMTc0MDcyMDY4MTE4MDgzQzNDMjA5MzREQ0ZDIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjAyODAxMTc0MDcyMDY4MTE4MDgzQzNDMjA5MzREQ0ZDIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+Af/+/fz7+vn49/b19PPy8fDv7u3s6+rp6Ofm5eTj4uHg397d3Nva2djX1tXU09LR0M/OzczLysnIx8bFxMPCwcC/vr28u7q5uLe2tbSzsrGwr66trKuqqainpqWko6KhoJ+enZybmpmYl5aVlJOSkZCPjo2Mi4qJiIeGhYSDgoGAf359fHt6eXh3dnV0c3JxcG9ubWxramloZ2ZlZGNiYWBfXl1cW1pZWFdWVVRTUlFQT05NTEtKSUhHRkVEQ0JBQD8+PTw7Ojk4NzY1NDMyMTAvLi0sKyopKCcmJSQjIiEgHx4dHBsaGRgXFhUUExIREA8ODQwLCgkIBwYFBAMCAQAAIfkEBQoAAgAsAAAAAAoACgAAAhWEERkn7W3ei7KlagMWF/dKgYeyGAUAIfkEBQoAAgAsAAAAAAoACgAAAg+UYwLJ7RnQm7QmsCyVKhUAIfkEBQoAAgAsAAAAAAoACgAAAhCUYgLJHdiinNSAVfOEKoUCACH5BAUKAAIALAAAAAAKAAoAAAIRVISAdusPo3RAzYtjaMIaUQAAIfkEBQoAAgAsAAAAAAoACgAAAg+MDiem7Q8bSLFaG5il6xQAIfkEBQoAAgAsAAAAAAoACgAAAg+UYRLJ7QnQm7SmsCyVKhUAIfkEBQoAAgAsAAAAAAoACgAAAhCUYBLJDdiinNSEVfOEKoECACH5BAUKAAIALAAAAAAKAAoAAAIRFISBdusPo3RBzYsjaMIaUQAAOw==")',
            borderImageSlice: '1',
            borderImageRepeat: 'repeat',
        },
        '& .ReactCrop--disabled .ReactCrop__crop-selection': {
            cursor: 'inherit',
        },
        '& .ReactCrop--circular-crop .ReactCrop__crop-selection': {
            borderRadius: '50%',
            boxShadow: '0px 0px 1px 1px white, 0 0 0 9999em rgba(0, 0, 0, 0.5)',
        },
        '& .ReactCrop__rule-of-thirds-vt::before, .ReactCrop__rule-of-thirds-vt::after, .ReactCrop__rule-of-thirds-hz::before, .ReactCrop__rule-of-thirds-hz::after':
            {
                content: "''",
                display: 'block',
                position: 'absolute',
                backgroundColor: 'rgba(255, 255, 255, 0.4)',
            },
        '& .ReactCrop__rule-of-thirds-vt::before, .ReactCrop__rule-of-thirds-vt::after': {
            width: 1,
            top: '0',
            bottom: '0',
        },
        '& .ReactCrop__rule-of-thirds-vt::before': {
            left: 'calc(100% / 3)',
            fallbacks: [
                {
                    left: '33.3333%',
                },
            ],
        },
        '& .ReactCrop__rule-of-thirds-vt::after': {
            left: 'calc(100% / 3 * 2)',
            fallbacks: [
                {
                    left: '66.6666%',
                },
            ],
        },
        '& .ReactCrop__rule-of-thirds-hz::before, .ReactCrop__rule-of-thirds-hz::after': {
            left: '0',
            right: '0',
            height: 1,
        },
        '& .ReactCrop__rule-of-thirds-hz::before': {
            top: 'calc(100% / 3)',
            fallbacks: [
                {
                    top: '33.3333%',
                },
            ],
        },
        '& .ReactCrop__rule-of-thirds-hz::after': {
            top: 'calc(100% / 3 * 2)',
            fallbacks: [
                {
                    top: '66.6666%',
                },
            ],
        },
        '& .ReactCrop__drag-handle': {
            position: 'absolute',
            width: 10,
            height: 10,
            backgroundColor: 'rgba(0, 0, 0, 0.2)',
            border: '1px solid rgba(255, 255, 255, 0.7)',
            boxSizing: 'border-box',
            outline: '1px solid transparent',
        },
        '& .ReactCrop .ord-nw': {
            top: '0',
            left: '0',
            marginTop: -5,
            marginLeft: -5,
            cursor: 'nw-resize',
        },
        '& .ReactCrop .ord-n': {
            top: '0',
            left: '50%',
            marginTop: -5,
            marginLeft: -5,
            cursor: 'n-resize',
        },
        '& .ReactCrop .ord-ne': {
            top: '0',
            right: '0',
            marginTop: -5,
            marginRight: -5,
            cursor: 'ne-resize',
        },
        '& .ReactCrop .ord-e': {
            top: '50%',
            right: '0',
            marginTop: -5,
            marginRight: -5,
            cursor: 'e-resize',
        },
        '& .ReactCrop .ord-se': {
            bottom: '0',
            right: '0',
            marginBottom: -5,
            marginRight: -5,
            cursor: 'se-resize',
        },
        '& .ReactCrop .ord-s': {
            bottom: '0',
            left: '50%',
            marginBottom: -5,
            marginLeft: -5,
            cursor: 's-resize',
        },
        '& .ReactCrop .ord-sw': {
            bottom: '0',
            left: '0',
            marginBottom: -5,
            marginLeft: -5,
            cursor: 'sw-resize',
        },
        '& .ReactCrop .ord-w': {
            top: '50%',
            left: '0',
            marginTop: -5,
            marginLeft: -5,
            cursor: 'w-resize',
        },
        '& .ReactCrop__disabled .ReactCrop__drag-handle': {
            cursor: 'inherit',
        },
        '& .ReactCrop__drag-bar': {
            position: 'absolute',
        },
        '& .ReactCrop__drag-bar.ord-n': {
            top: '0',
            left: '0',
            width: '100%',
            height: 6,
            marginTop: -3,
        },
        '& .ReactCrop__drag-bar.ord-e': {
            right: '0',
            top: '0',
            width: 6,
            height: '100%',
            marginRight: -3,
        },
        '& .ReactCrop__drag-bar.ord-s': {
            bottom: '0',
            left: '0',
            width: '100%',
            height: 6,
            marginBottom: -3,
        },
        '& .ReactCrop__drag-bar.ord-w': {
            top: '0',
            left: '0',
            width: 6,
            height: '100%',
            marginLeft: -3,
        },
        '& .ReactCrop--new-crop .ReactCrop__drag-bar, .ReactCrop--new-crop .ReactCrop__drag-handle, .ReactCrop--fixed-aspect .ReactCrop__drag-bar':
            {
                display: 'none',
            },
        '& .ReactCrop--fixed-aspect .ReactCrop__drag-handle.ord-n, .ReactCrop--fixed-aspect .ReactCrop__drag-handle.ord-e, .ReactCrop--fixed-aspect .ReactCrop__drag-handle.ord-s, .ReactCrop--fixed-aspect .ReactCrop__drag-handle.ord-w':
            {
                display: 'none',
            },
    },
    icon: {
        marginBottom: 4,
    },
    dropText: {
        lineHeight: '20px',
        marginBottom: 4,
    },
    hintText: {},
    '@media (pointer: coarse)': {
        cropImage: {
            '& .ReactCrop__drag-handle': {
                width: 34,
                height: 34,
            },
            '& .ReactCrop__drag-bar': {
                display: 'none',
            },
            '& .ReactCrop .ord-nw, .ReactCrop .ord-n, .ReactCrop .ord-ne, .ReactCrop .ord-e, .ReactCrop .ord-s, .ReactCrop .ord-sw, .ReactCrop .ord-w':
                {
                    display: 'none',
                },
            '& .ReactCrop .ord-se': {
                marginBottom: -1,
                marginRight: -1,
            },
        },
    },
});
